import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import AuthAction from './pages/AuthAction';
import Home from './pages/Home';
import CompanyBrandingPage from './pages/CompanyBrandingPage';
import RemovedFromCompany from './pages/RemovedFromCompany';
import ProjectDashboard from './pages/ProjectDashboard';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import GanttLanding from './pages/GanttLanding';
import TeamsLanding from './pages/TeamsLanding';
import AttendanceLanding from './pages/AttendanceLanding';
import DesignLanding from './pages/DesignLanding';
import MapLanding from './pages/MapLanding';
import DocumentLanding from './pages/DocumentLanding';
import ActivityLanding from './pages/ActivityLanding';
import SnagsLanding from './pages/SnagsLanding';
import EmergencyLanding from './pages/EmergencyLanding';
import SupportDocumentsLanding from './pages/SupportDocumentsLanding';
import ProjectTeam from './pages/ProjectTeam';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider, useBranding } from './contexts/BrandingContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AuthLoadingSpinner from './components/AuthLoadingSpinner';
// Main App component

function AppRoutes() {
  const { loading: appShellLoading } = useBranding();

  /** `useBranding().loading` mirrors auth bootstrap; splash is always Crewchain + default chrome. */
  if (appShellLoading) {
    return <AuthLoadingSpinner />;
  }

  return (
    <>
      <Routes>
        {/* Default route for login */}
        <Route path="/" element={<Login />} />

        {/* Firebase Auth email action handler (password reset, verify email, recover email) —
            replaces the default <project-id>.firebaseapp.com page. Must stay unauthenticated:
            reached from an emailed link, before any sign-in exists. See AuthAction.jsx. */}
        <Route path="/auth/action" element={<AuthAction />} />

        {/* Removed from company screen (must still be authenticated) */}
        <Route path="/removed" element={<ProtectedRoute><RemovedFromCompany /></ProtectedRoute>} />

        {/* Protected routes */}
        <Route path="/" element={<Layout />}>
          <Route path="home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="home/branding" element={<ProtectedRoute><CompanyBrandingPage /></ProtectedRoute>} />
          <Route path="project/:projectId" element={<ProtectedRoute><ProjectDashboard /></ProtectedRoute>} />
          <Route path="project/:projectId/gantt" element={<ProtectedRoute><GanttLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/teams" element={<ProtectedRoute><TeamsLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/design" element={<ProtectedRoute><DesignLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/attendance" element={<ProtectedRoute><AttendanceLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/documents" element={<ProtectedRoute><DocumentLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/map" element={<ProtectedRoute><MapLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/activity" element={<ProtectedRoute><ActivityLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/snag" element={<ProtectedRoute><SnagsLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/emergency" element={<ProtectedRoute><EmergencyLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/support-documents" element={<ProtectedRoute><SupportDocumentsLanding /></ProtectedRoute>} />
          <Route path="project/:projectId/team" element={<ProtectedRoute><ProjectTeam /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrandingProvider>
          <AppRoutes />
        </BrandingProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
